import Styled from "styled-components";

export interface ContentProps {
  $layoutType?: "image-left" | "image-right";
  $variant?: "standard" | "grey-box";
  $reverseOrderOnMobil?: boolean | null;
}

export interface IllustrationProps {
  $imageFit?: "cover" | "contain";
  $layoutType?: "image-left" | "image-right";
  $variant?: "standard" | "grey-box";
}

export interface MessageProps {
  $layoutType?: "image-left" | "image-right";
  $variant?: "standard" | "grey-box";
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-direction: ${(props) =>
    props.$reverseOrderOnMobil ? "column" : "column-reverse"} ;
  gap:  ${(props) => (props.$reverseOrderOnMobil ? "1rem" : "3.125rem;")} ;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    flex-direction: row;
    gap: 2rem;
    
    ${(props) =>
      props.$layoutType === "image-right" &&
      `
      flex-direction: row-reverse;
    `};
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 6rem;
    max-width: calc(100% - 10rem);
  }

  ${(props) =>
    props.$variant === "standard" &&
    `
    background-color: transparent;
  `}

  ${(props) =>
    props.$variant === "grey-box" &&
    `
    background-color: #FAFAFA;
    border-radius: 1rem;
  `}
`;

export const Illustration = Styled.div<IllustrationProps>`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  max-height: 35rem;
  border-radius: 1rem;

  .gatsby-image-wrapper {
    max-height: 35rem;
  }

  ${(props) =>
    props.$imageFit === "cover" &&
    `
    .gatsby-image-wrapper {
      width: 100%;
      height: 100%;
    }
  `}

  ${(props) =>
    props.$variant === "grey-box" &&
    `
      max-height: 13.75rem;
      border-radius: 0px 0px 1rem 1rem;

      .gatsby-image-wrapper {
        max-height: 13.75rem;
      }
  `}

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;

    ${(props) =>
      props.$variant === "grey-box" &&
      `
      min-height: 37.5rem;
      border-radius: 1rem 0px 0px 1rem;

      .gatsby-image-wrapper {
        min-height: 37.5rem;
      }
    `}

    ${(props) =>
      props.$variant === "grey-box" &&
      props.$layoutType === "image-right" &&
      `
      border-radius: 0px 1rem 1rem 0px;
    `}
  }


  ${(props) => props.theme.breakpoints.up("large")} {

    ${(props) =>
      props.$variant === "grey-box" &&
      `
      flex: 0.4;
    `}
  }
`;

export const Message = Styled.div<MessageProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
    
  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;
    
    ${(props) =>
      props.$variant === "grey-box" &&
      `
      flex: 0.6;
      padding-right: 1.75rem;
    `}

    ${(props) =>
      props.$variant === "grey-box" &&
      props.$layoutType === "image-right" &&
      `
      padding-left: 1.75rem;
      padding-right: 0;
    `}
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 1.875rem;

    ${(props) =>
      props.$variant === "grey-box" &&
      `
      padding-right: 3.75rem;
    `}

    ${(props) =>
      props.$variant === "grey-box" &&
      props.$layoutType === "image-right" &&
      `
      padding-left: 3.75rem;
      padding-right: 0;
    `}
  }
`;

export const Tagline = Styled.span`
  color: #7F7F7F;
  font-size: 1rem;
  font-weight: 600;

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.25rem;
  }
`;

export const Pitch = Styled.div`
  font-size: 1.25rem;
  line-height: 1.565rem;
  font-weight: 400;
  letter-spacing: -0.2px;
  margin-bottom: 1.875rem;

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.625rem;
    line-height: 2.03rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;
